import { Component, ViewChild,AfterViewInit,ElementRef,Output,EventEmitter,Input } from '@angular/core';
import {WsService} from '../../utils/network/ws.service';
import {Modal} from 'ng2-modal';

import {SessionManagerService} from '../services/session/session-manager.service';

import {RoomManagerService} from '../services/room/room-manager.service';
import {WsService2} from '../services/ws/ws.service';
@Component({
  selector: "dskl-tools-add-task",
  templateUrl: 'add-task.component.html',
  
})
export class AddTaskComponent {
  @ViewChild("toolsModal") toolsModal: Modal;
  
  constructor(private wsService: WsService2, private sessionManager: SessionManagerService, private roomManager: RoomManagerService){}
  open(){
    this.check = false;
    this.g = {name:"", wbTypes:[], withoutGroups: true, groupWork: false, singleBoards: true, groups:[] };
    this.toolsModal.open();
    
  }
  check=false;
  g: any = {name:"", wbTypes:[], withoutGroups: true, groupWork: false };
  
  get diagnostic() {
    return JSON.stringify(this.g);
  }
  selected(o, index) {
    this.g.wbTypes[index]=o.desk.value;
    
  }

  setGroups(n){
    n = +n;
    if (typeof n =='number' && n <6){
      
        this.g.groups = new Array(n);
        var users = [];
        for (let k in this.roomManager.getPeers()){
          var u = this.roomManager.getPeers()[k];
          if (u.who!=this.wsService.getMe()){
            users.push(u);
          }
        }
        
        var ing = Math.round(users.length/n);
          
        for (var i=0;i<n;i++){
          this.g.groups[i]={name:"", users:[]};
          
          var f;
          if (i+1==n)
            f = users.length;
            else f = (i+1)*ing
          for (var j=i*ing; j<f;j++){
            if (users[j])
            this.g.groups[i].users.push(users[j]);
          }
        }
      
    }else{
      this.g.groups = [];
    }
  }
createSession(){
  
  this.check = true;
  var _this = this;
  setTimeout(function(){
_this.check =false;
  }, 2000)
  
  if (this.g.name.length==0)return;
  if (this.g.singleBoards && this.g.wbTypes.length==0)return;
  if (!this.g.singleBoards && this.g.wbTypes.length!=2)return;
  if (this.g.groupWork && this.g.groups.length==0)return;
  
  var session ={name: this.g.name, wbTypes: this.g.wbTypes, groupWork: this.g.groupWork, groups: this.g.groups};
  
  this.sessionManager.createSession(session);

 this.toolsModal.close();
}
}



// WEBPACK FOOTER //
// /app/src/app/wb/tools/add-task.component.ts